gsap.registerPlugin(MorphSVGPlugin, ScrollTrigger);

const arIframes = document.querySelectorAll('iframe');

for (let i = 0; i < arIframes.length; i++) {
    const iframe = arIframes[i];
    const aspectRatio = getIframeAspectRatio(iframe);

    setIframeAspectRatio(iframe, aspectRatio);
    window.addEventListener('resize', _ => setIframeAspectRatio(iframe, aspectRatio));
}

function setIframeAspectRatio(iFrameElement, ratio) {
    iFrameElement.style.height = Math.min(((iFrameElement.offsetWidth / ratio[0]) * ratio[1]), window.innerHeight * 0.8) + 'px';
}

function getIframeAspectRatio(iframe) {
    let aspectRatio = iframe.dataset.aspectRatio;

    if (aspectRatio) {
        aspectRatio = aspectRatio.split(':');
    }
    else {
        const definedWidth = iframe.getAttribute('width');
        const definedHeight = iframe.getAttribute('height');

        aspectRatio = [1, (definedHeight / definedWidth)];
    }

    return aspectRatio
}
/**
 * Do an AJAX request
 * @param parameters [{'key': 'value'}]
 * @param successCallback
 * @param errorCallback
 */
function se_postRequest(postUrl, parameters, successCallback, errorCallback) {
    const xmlHttp = new XMLHttpRequest();

    // Add the parameters
    const params = new FormData();
    const parameterKeys = Object.keys(parameters);

    for (let i = 0; i < parameterKeys.length; i++) params.append(parameterKeys[i], parameters[parameterKeys[i]]);

    xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState === XMLHttpRequest.DONE) {
            if (xmlHttp.status === 200) {
                if (typeof successCallback !== 'undefined') successCallback(xmlHttp.responseText);
            }
            else {
                if (typeof errorCallback !== 'undefined') errorCallback();
            }
        }
    };

    xmlHttp.open('POST', postUrl, true);
    xmlHttp.send(params);
}
function CommuneHeader(el) {
    this.el = el;
    this.videoWrapper = this.el.querySelector('.jsCommuneHeaderVideoWrapper');
    this.videoEl = this.el.querySelector('.jsCommuneHeaderVideo');

    // Init VideoJS
    if (this.videoEl) {
        videojs(this.videoEl);
        this.videoWrapperEl = this.videoWrapper.querySelector('div');
    }

    // Set the header video aspect ratio
    this.setAspectRatio();
    window.addEventListener('resize', _ => this.setAspectRatio());

    const downButtonEl = this.el.querySelector('.jsDownBtn');
    downButtonEl.addEventListener('click', e => {
        e.preventDefault();

        const offset = this.el.getBoundingClientRect();
        vanillaSmoothie.scrollTo(window.scrollY + (this.el.offsetHeight + offset.top), { duration: 500, easing: 'easeInOutQuad' });
    });
}

CommuneHeader.prototype.setAspectRatio = function() {
    if (this.videoWrapperEl) {
        const ratio = [16, 9];
        const minHeight = this.el.offsetHeight;

        this.videoWrapperEl.style.width = '';
        this.videoWrapperEl.style.height = '';

        let newWidth = window.innerWidth;
        let newHeight = (this.videoWrapperEl.offsetWidth / ratio[0]) * ratio[1];

        if (newHeight < minHeight) {
            newHeight = minHeight;
            newWidth = (newHeight / ratio[1]) * ratio[0];
        }

        this.videoWrapperEl.style.width = newWidth + 'px';
        this.videoWrapperEl.style.height = newHeight + 'px';
    }
};

(function() {
    const headerEl = document.querySelector('.jsCommuneHeader');
    if (headerEl) new CommuneHeader(headerEl);
})();
function CarriersSlider(el) {
    this.el = el;

    new Flickity(this.el, {
        contain: true,
        prevNextButtons: false,
        imagesLoaded: true,
        pageDots: false
    });
}

(function() {
    const carriersSliderEl = document.querySelector('.jsCarriersSlider');
    if (carriersSliderEl) new CarriersSlider(carriersSliderEl);
})();
function PartnerSlider(el) {
    this.el = el;

    new Flickity(this.el, {
        contain: true,
        prevNextButtons: false,
        imagesLoaded: true,
        autoPlay: 2000,
        pageDots: false
    });
}

(function() {
    const partnerSliderEl = document.querySelector('.jsPartnerBlockSlider');
    if (partnerSliderEl) new PartnerSlider(partnerSliderEl);
})();

function BackToTop(el) {
    this.el = el;

    this.el.addEventListener('click', e => {
        e.preventDefault();
        
        vanillaSmoothie.scrollTo(0, { duration: 500, easing: 'easeOutQuad' });

        document.activeElement.blur();
    });

    this.setVisibility();
    window.addEventListener('scroll', _ => this.setVisibility());
}

BackToTop.prototype.setVisibility = function() {
    if (window.scrollY > window.innerHeight * 0.5) this.el.classList.add('visible');
    else this.el.classList.remove('visible');
};

(function() {
    const backToTopBtnEl = document.querySelector('.jsBackToTop');
    if (backToTopBtnEl) new BackToTop(backToTopBtnEl);
})();
function MobileMenu(el, triggerEl) {
    this.el = el;
    this.triggerEl = triggerEl;
    this.focusedElBeforeOpen = null;
    this.focusableEls = [this.triggerEl, ...this.el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')];
    this.firstFocusableEl = this.focusableEls[0];
    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];

    this.triggerEl.addEventListener('click', e => {
        e.preventDefault();
        this.toggleVisibility();
    });

    window.addEventListener('resize', _ => { if (window.innerWidth >= 1450) this.hide() });
    window.addEventListener('keyup', e => { if (e.key.toLowerCase() == 'escape') this.hide() });

    window.addEventListener('keydown', e => {
        const tabIsPressed = e.key === 'Tab';

        if (!tabIsPressed) return;

        if (e.shiftKey) {
            if (document.activeElement === this.firstFocusableEl) {
                this.lastFocusableEl.focus();
                e.preventDefault();
            }
        }
        else {
            if (document.activeElement === this.lastFocusableEl) {
                this.firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    });
}

MobileMenu.prototype.toggleVisibility = function() {
    if (this.el.classList.contains('open')) this.hide();
    else this.show();
};

MobileMenu.prototype.show = function() {
    this.triggerEl.classList.add('open');

    // Prevent overflow on the HTML and body
    document.documentElement.classList.add('no-overflow');
    document.body.classList.add('no-overflow');

    // Accessibility stuff
    this.focusedElBeforeOpen = document.activeElement;
    this.el.focus();
    document.body.ariaHidden = true;
    this.el.ariaHidden = false;
    this.triggerEl.ariaExpanded = true;
    this.triggerEl.ariaLabel = 'Verberg het hoofdmenu';

    // Show animation
    const slideInEls = [this.el.querySelector('.jsMobileMenuAccessBtns'), ...this.el.querySelectorAll('.mobile-main-menu li')];
    const footerBottomEl = this.el.querySelector('.jsMobileMenuBottom');

    gsap.timeline()
        .set(this.el, { xPercent: 100, display: 'block' })
        .set([...slideInEls, footerBottomEl], { y: 20, opacity: 0 })

        .to(this.el, 0.5, { xPercent: 0, ease: Power2.easeInOut })
        .to(slideInEls, 0.5, { y: 0, opacity: 1, stagger: 0.08, ease: Power2.easeInOut }, '-=0.2')
        .to(footerBottomEl, 0.5, { y: 0, opacity: 1 }, '-=0.7')

        .add(_ => this.el.classList.add('open'))
        .set([this.el, ...slideInEls, footerBottomEl], { clearProps: 'all' })
    ;
};

MobileMenu.prototype.hide = function() {
    if (this.el.classList.contains('open')) {
        this.triggerEl.classList.remove('open');

        // Reset overflow on the HTML and body
        document.documentElement.classList.remove('no-overflow');
        document.body.classList.remove('no-overflow');

        // Accessibility stuff
        this.focusedElBeforeOpen = null;
        document.body.ariaHidden = false;
        this.el.ariaHidden = true;
        this.triggerEl.ariaExpanded = false;
        this.triggerEl.ariaLabel = 'Toon het hoofdmenu';

        if (window.innerWidth >= 1000) document.body.querySelector('.jsTopLogo').focus();
        else if (this.focusedElBeforeOpen) this.focusedElBeforeOpen.focus();

        // Show animation
        const slideInEls = [this.el.querySelector('.jsMobileMenuAccessBtns'), ...this.el.querySelectorAll('.mobile-main-menu li')];
        const footerBottomEl = this.el.querySelector('.jsMobileMenuBottom');

        gsap.timeline()
            .to(slideInEls, 0.5, { y: 20, opacity: 0, stagger: 0.08, ease: Power2.easeInOut })
            .to(footerBottomEl, 0.5, { y: 20, opacity: 0, ease: Power2.easeInOut }, '-=0.5')
            .to(this.el, 0.5, { xPercent: 100, ease: Power2.easeInOut }, '-=0.2')

            .add(_ => this.el.classList.remove('open'))
            .set([this.el, ...slideInEls, footerBottomEl], { clearProps: 'all' })
        ;
    }
};

(function() {
    const mobileMenuTriggerEl = document.querySelector('.jsMobileMenuTrigger');

    if (mobileMenuTriggerEl) {
        const mobileMenuEl = document.querySelector('.jsMobileMenu');
        new MobileMenu(mobileMenuEl, mobileMenuTriggerEl);
    }
})();
function CarrierModal(el) {
    this.el = el;

    this.innerEl = this.el.querySelector('.jsCarrierModalInner');
    this.focusedElBeforeOpen = null;
    this.focusableEls = this.el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    this.firstFocusableEl = this.focusableEls[0];
    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];

    this.el.addEventListener('click', e => {
        this.setHideCookie();
        if (e.target.classList.contains('jsCloseModal')) this.hide();
    });

    window.addEventListener('keyup', e => {
        if (e.key.toLowerCase() === 'escape') this.hide();
    });

    window.addEventListener('keydown', e => {
        const tabIsPressed = e.key === 'Tab';

        if (!tabIsPressed) return;

        if (e.shiftKey) {
            if (document.activeElement === this.firstFocusableEl) {
                this.lastFocusableEl.focus();
                e.preventDefault();
            }
        }
        else {
            if (document.activeElement === this.lastFocusableEl) {
                this.firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    });
}

CarrierModal.prototype.show = function() {
    return;

    if (this.el.classList.contains('show')) return;

    // Animation
    gsap.timeline()
        .set(this.el, { display: 'flex', opacity: 0 })
        .set(this.innerEl, { y: 20, opacity: 0 })

        .to(this.el, { duration: 0.5, y: 0, opacity: 1, ease: 'power2.inOut' })
        .to(this.innerEl, { duration: 0.5, y: 0, opacity: 1, ease: 'power2.inOut' }, '-=0.5')
        
        .add(_ => {
            this.el.classList.add('show');

            // Set focus to the button element
            setTimeout(_ => this.el.querySelector('.jsCarrierModalBtn').focus(), 200);
        })
        .set(this.el, { clearProps: 'all' })
    ;

    // Prevent overflow on the HTML and body
    document.documentElement.classList.add('no-overflow');
    document.body.classList.add('no-overflow');

    // Accessibility stuff
    this.focusedElBeforeOpen = document.activeElement;
    this.firstFocusableEl.focus();
    document.body.ariaHidden = true;
    this.el.ariaHidden = false;
};

CarrierModal.prototype.hide = function() {
    this.setHideCookie();

    // Animation
    gsap.timeline()
        .to(this.el, 0.5, { opacity: 0, ease: 'power2.inOut' })
        .to(this.innerEl, { y: 20, opacity: 0, ease: 'power2.inOut' }, '-=0.5')

        .add(_ => {
            this.el.classList.remove('show');
            if (this.focusedElBeforeOpen) this.focusedElBeforeOpen.focus();
            this.focusedElBeforeOpen = null;
        })
        .set(this.el, { clearProps: 'all' })
    ;

    document.documentElement.classList.remove('no-overflow');
    document.body.classList.remove('no-overflow');

    // Accessibility stuff
    if (this.focusedElBeforeOpen) this.focusedElBeforeOpen.focus();
    document.body.ariaHidden = false;
    this.el.ariaHidden = true;
};

CarrierModal.prototype.setHideCookie = function() {
    const cookieName = 'functional_carrier_modal_hide';
    const cookieValue = 'true';
    const date = new Date();

    date.setDate(date.getDate() + 1);

    document.cookie = cookieName + '=' + cookieValue + ';expires=' + date + ';path=/';
};

CarrierModal.prototype.getCookie = function(name) {
    const dc = document.cookie;
    const prefix = name + '=';
    let end = '';
    let begin = dc.indexOf('; ' + prefix);

    if (begin === -1) {
        begin = dc.indexOf(prefix);
        if (begin !== 0) return null;
    }
    else {
        begin += 2;
        end = document.cookie.indexOf(";", begin);

        if (end === -1) end = dc.length;
    }

    return decodeURI(dc.substring(begin + prefix.length, end));
};

(function() {
    const carrierModalEl = document.querySelector('.jsCarrierModal');
    if (carrierModalEl) {
        const carrierModal = new CarrierModal(carrierModalEl);
        if (carrierModal.getCookie('functional_carrier_modal_hide') === null) carrierModal.show();
    }
})();
function RulesModal(el) {
    this.el = el;

    this.innerEl = this.el.querySelector('.jsRulesModalInner');
    this.focusedElBeforeOpen = null;
    this.focusableEls = this.el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    this.firstFocusableEl = this.focusableEls[0];
    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];

    this.el.addEventListener('click', e => {
        this.setHideCookie();
        if (e.target.classList.contains('jsCloseModal')) this.hide();
    });

    window.addEventListener('keyup', e => {
        if (e.key.toLowerCase() === 'escape') this.hide();
    });

    window.addEventListener('keydown', e => {
        const tabIsPressed = e.key === 'Tab';

        if (!tabIsPressed) return;

        if (e.shiftKey) {
            if (document.activeElement === this.firstFocusableEl) {
                this.lastFocusableEl.focus();
                e.preventDefault();
            }
        }
        else {
            if (document.activeElement === this.lastFocusableEl) {
                this.firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    });
}

RulesModal.prototype.show = function() {
    if (this.el.classList.contains('show')) return;

    // Animation
    gsap.timeline()
        .set(this.el, { display: 'flex', opacity: 0 })
        .set(this.innerEl, { y: 20, opacity: 0 })

        .to(this.el, { duration: 0.5, y: 0, opacity: 1, ease: 'power2.inOut' })
        .to(this.innerEl, { duration: 0.5, y: 0, opacity: 1, ease: 'power2.inOut' }, '-=0.5')

        .add(_ => {
            this.el.classList.add('show');

            // Set focus to the button element
            setTimeout(_ => this.el.querySelector('.jsCloseModal').focus(), 200);
        })
        .set(this.el, { clearProps: 'all' })
    ;

    // Prevent overflow on the HTML and body
    document.documentElement.classList.add('no-overflow');
    document.body.classList.add('no-overflow');

    // Accessibility stuff
    this.focusedElBeforeOpen = document.activeElement;
    this.firstFocusableEl.focus();
    document.body.ariaHidden = true;
    this.el.ariaHidden = false;
};

RulesModal.prototype.hide = function() {
    this.setHideCookie();

    // Animation
    gsap.timeline()
        .to(this.el, 0.5, { opacity: 0, ease: 'power2.inOut' })
        .to(this.innerEl, { y: 20, opacity: 0, ease: 'power2.inOut' }, '-=0.5')

        .add(_ => {
            this.el.classList.remove('show');
            if (this.focusedElBeforeOpen) this.focusedElBeforeOpen.focus();
            this.focusedElBeforeOpen = null;
        })
        .set(this.el, { clearProps: 'all' })
    ;

    document.documentElement.classList.remove('no-overflow');
    document.body.classList.remove('no-overflow');

    // Accessibility stuff
    if (this.focusedElBeforeOpen) this.focusedElBeforeOpen.focus();
    document.body.ariaHidden = false;
    this.el.ariaHidden = true;
};

RulesModal.prototype.setHideCookie = function() {
    const cookieName = 'functional_carrier_modal_hide';
    const cookieValue = 'true';
    const date = new Date();

    date.setDate(date.getDate() + 1);

    document.cookie = cookieName + '=' + cookieValue + ';expires=' + date + ';path=/';
};

RulesModal.prototype.getCookie = function(name) {
    const dc = document.cookie;
    const prefix = name + '=';
    let end = '';
    let begin = dc.indexOf('; ' + prefix);

    if (begin === -1) {
        begin = dc.indexOf(prefix);
        if (begin !== 0) return null;
    }
    else {
        begin += 2;
        end = document.cookie.indexOf(";", begin);

        if (end === -1) end = dc.length;
    }

    return decodeURI(dc.substring(begin + prefix.length, end));
};

(function() {
    const rulesModalEl = document.querySelector('.jsRulesModal');
    if (rulesModalEl) {
        const rulesModal = new RulesModal(rulesModalEl);
        const triggerEls = document.querySelectorAll('.jsRulesModalBtn');

        triggerEls.forEach(triggerEl => {
            triggerEl.addEventListener('click', e => {
                e.preventDefault();
                rulesModal.show();
            });
        });
    }
})();
function PhotoCompetitionModal(el) {
    this.el = el;

    this.innerEl = this.el.querySelector('.jsPhotoCompetitionModalInner');
    this.contentEl = this.el.querySelector('.jsContent');
    this.focusedElBeforeOpen = null;
    this.focusableEls = this.el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    this.firstFocusableEl = this.focusableEls[0];
    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];
    this.voteFormTriggerEl = this.el.querySelector('.jsVoteFormTrigger');
    this.voteFormEl = this.el.querySelector('.jsVoteForm');
    this.voteFormInputEl = this.voteFormEl ? this.voteFormEl.querySelector('input') : null;
    this.formSuccessEl = this.el.querySelector('.jsFormSuccess');
    this.formErrorEl = this.el.querySelector('.jsFormError');
    this.content = {};

    this.el.addEventListener('click', e => {
        if (e.target.classList.contains('jsCloseModal')) this.hide();
    });

    window.addEventListener('keyup', e => {
        if (e.key.toLowerCase() === 'escape') this.hide();
    });

    window.addEventListener('keydown', e => {
        const tabIsPressed = e.key === 'Tab';

        if (!tabIsPressed) return;

        if (e.shiftKey) {
            if (document.activeElement === this.firstFocusableEl) {
                this.lastFocusableEl.focus();
                e.preventDefault();
            }
        }
        else {
            if (document.activeElement === this.lastFocusableEl) {
                this.firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    });

    if (this.voteFormTriggerEl) {
        this.voteFormTriggerEl.addEventListener('click', e => {
            e.preventDefault();
            this.focusVoteFormInput();
        });
    }

    if (this.voteFormEl) {
        this.voteFormEl.addEventListener('submit', e => {
            e.preventDefault();

            const email = this.voteFormInputEl.value.trim();

            if (! email) {
                alert('Vul een e-mailadres in.');
                this.focusVoteFormInput();
                return;
            }

            this.el.classList.add('loading');

            se_postRequest(se_ajax.ajaxurl, {
                action: 'send_photo_competition_vote',
                email: email,
                photo_id: this.content.photo_id,
                category: this.content.category_slug
            }, response => {
                this.el.classList.remove('loading');
                const data = JSON.parse(response);

                if (data.success) {
                    this.hideError();
                    this.el.classList.add('success');
                    this.voteFormEl.style.display = 'none';
                }
                else {
                    this.el.classList.add('error');
                    this.displayError(data.message);
                }
            }, () => {
                this.el.classList.remove('loading');
                this.el.classList.add('error');
                this.displayError('general-error');
            });
        });
    }
}

PhotoCompetitionModal.prototype.focusVoteFormInput = function() {
    this.voteFormInputEl.focus();
};

PhotoCompetitionModal.prototype.displayError = function(errorCode) {
    const errorMessages = {
        'enter-valid-email': 'Vul een geldig e-mailadres in.',
        'already-voted-in-this-category': 'Je hebt al gestemd in deze leeftijdsgroep.',
        'failed-to-send-vote': 'Het versturen van je stem is mislukt. Probeer het opnieuw.',
        'general-error': 'Er is een fout opgetreden. Probeer het opnieuw.'
    };

    const message = errorMessages[errorCode] || errorMessages['general-error'];

    if (this.formErrorEl) {
        this.formErrorEl.textContent = message;
        this.formErrorEl.style.display = 'block';
    }
};

PhotoCompetitionModal.prototype.hideError = function() {
    if (this.formErrorEl) {
        this.formErrorEl.style.display = 'none';
    }
};

PhotoCompetitionModal.prototype.resetForm = function() {
    this.el.classList.remove('success', 'error', 'loading');
    if (this.voteFormInputEl) this.voteFormInputEl.value = '';
    if (this.voteFormEl) this.voteFormEl.style.display = '';

    this.hideError();
};

PhotoCompetitionModal.prototype.show = function(focusInput = false) {
    if (this.el.classList.contains('show')) return;

    // Hide any previous error messages
    this.hideError();

    // Animation
    gsap.timeline()
        .set(this.el, { display: 'flex', opacity: 0 })
        .set(this.innerEl, { y: 20, opacity: 0 })

        .to(this.el, { duration: 0.5, y: 0, opacity: 1, ease: 'power2.inOut' })
        .to(this.innerEl, { duration: 0.5, y: 0, opacity: 1, ease: 'power2.inOut' }, '-=0.5')

        .add(_ => {
            this.el.classList.add('show');

            setTimeout(_ => {
                if (focusInput) this.focusVoteFormInput();
                else this.el.querySelector('.jsCloseModal').focus()
            }, 200);
        })
        .set(this.el, { clearProps: 'all' })
    ;

    // Prevent overflow on the HTML and body
    document.documentElement.classList.add('no-overflow');
    document.body.classList.add('no-overflow');

    // Accessibility stuff
    this.focusedElBeforeOpen = document.activeElement;
    this.firstFocusableEl.focus();
    document.body.ariaHidden = true;
    this.el.ariaHidden = false;
};

PhotoCompetitionModal.prototype.hide = function() {
    // Animation
    gsap.timeline()
        .to(this.el, 0.5, { opacity: 0, ease: 'power2.inOut' })
        .to(this.innerEl, { y: 20, opacity: 0, ease: 'power2.inOut' }, '-=0.5')

        .add(_ => {
            this.el.classList.remove('show');
            if (this.focusedElBeforeOpen) this.focusedElBeforeOpen.focus();
            this.focusedElBeforeOpen = null;
        })
    .set(this.el, { clearProps: 'all' });

    document.documentElement.classList.remove('no-overflow');
    document.body.classList.remove('no-overflow');

    // Reset form and states
    this.resetForm();

    // Accessibility stuff
    if (this.focusedElBeforeOpen) this.focusedElBeforeOpen.focus();
    document.body.ariaHidden = false;
    this.el.ariaHidden = true;
};

PhotoCompetitionModal.prototype.setContent = function(content) {
    this.content = content;
    this.el.querySelector('.jsImg').src = content.photo_img_url;
    this.el.querySelector('.jsUserName').textContent = content.user_name;
    this.el.querySelector('.jsCategory').textContent = `Categorie: ${content.category}`;
    this.el.querySelector('.jsPhotoName').textContent = `‘${content.photo_name}’`;
    this.el.querySelector('.jsDescription').innerHTML = content.photo_description;
};

(function() {
    // Only initialize if there are photo competition modal triggers on the page
    const triggerEls = document.querySelectorAll('[data-photo-competition-modal-trigger]');

    if (triggerEls.length > 0) {
        const photoCompetitionModalEl = document.querySelector('.jsPhotoCompetitionModal');

        if (photoCompetitionModalEl) {
            const photoCompetitionModal = new PhotoCompetitionModal(photoCompetitionModalEl);

            triggerEls.forEach(triggerEl => {
                triggerEl.addEventListener('click', e => {
                    e.preventDefault();

                    // Get photo info from data attribute
                    const photoInfo = JSON.parse(triggerEl.getAttribute('data-photo-info'));
                    if (photoInfo) photoCompetitionModal.setContent(photoInfo);

                    photoCompetitionModal.show(triggerEl.getAttribute('data-photo-competition-modal-trigger') === 'vote');
                });
            });
        }
    }
})();
function ZipCodeCheckModal(el) {
    this.el = el;

    this.focusedElBeforeOpen = null;
    this.focusableEls = this.el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    this.firstFocusableEl = this.focusableEls[0];
    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];

    this.el.addEventListener('click', e => {
        if (e.target.classList.contains('jsCloseModal')) this.hide();
    });

    window.addEventListener('keyup', e => {
        if (e.key.toLowerCase() === 'escape') this.hide();
    });

    window.addEventListener('keydown', e => {
        const tabIsPressed = e.key === 'Tab';

        if (!tabIsPressed) return;

        if (e.shiftKey) {
            if (document.activeElement === this.firstFocusableEl) {
                this.lastFocusableEl.focus();
                e.preventDefault();
            }
        }
        else {
            if (document.activeElement === this.lastFocusableEl) {
                this.firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    });
}

ZipCodeCheckModal.prototype.show = function() {
    if (this.el.classList.contains('show')) return;

    // Animation
    gsap.timeline()
        .set(this.el, { y: 20, display: 'flex', opacity: 0 })
        .to(this.el, 0.5, { y: 0, opacity: 1, ease: Power2.easeInOut })
        
        .add(_ => {
            this.el.classList.add('show');
            window.location.hash = 'postcodecheck';

            // Set focus to the input field
            setTimeout(_ => this.el.querySelector('.jsZipCodeCheckInput').focus(), 200);
        })
        .set(this.el, { clearProps: 'all' })
    ;

    // Prevent overflow on the HTML and body
    document.documentElement.classList.add('no-overflow');
    document.body.classList.add('no-overflow');

    // Accessibility stuff
    this.focusedElBeforeOpen = document.activeElement;
    this.firstFocusableEl.focus();
    document.body.ariaHidden = true;
    this.el.ariaHidden = false;
};

ZipCodeCheckModal.prototype.hide = function() {
    // Animation
    gsap.timeline()
        .to(this.el, 0.5, { y: 20, opacity: 0, ease: Power2.easeInOut })

        .add(_ => {
            this.el.classList.remove('show');
            if (this.focusedElBeforeOpen) this.focusedElBeforeOpen.focus();
            this.focusedElBeforeOpen = null;
            window.location.hash = '';
        })
        .set(this.el, { clearProps: 'all' })
    ;

    document.documentElement.classList.remove('no-overflow');
    document.body.classList.remove('no-overflow');

    // Accessibility stuff
    if (this.focusedElBeforeOpen) this.focusedElBeforeOpen.focus();
    document.body.ariaHidden = false;
    this.el.ariaHidden = true;
};

(function() {
    const zipCodeCheckModalEl = document.querySelector('.jsZipCodeModal');
    if (zipCodeCheckModalEl) {
        const zipCodeCheckModal = new ZipCodeCheckModal(zipCodeCheckModalEl);

        document.body.addEventListener('click', e => {
            if (e.target.classList.contains('jsZipCodeCheckModalTrigger')) {
                e.preventDefault();
                zipCodeCheckModal.show();
            }
        });

        // Check if we have the zipcode trigger hashtag and if, open the zipcode check modal
        if (window.location.hash === '#postcodecheck') {
            zipCodeCheckModal.show();
        }
    }
})();
function ZipCodeCheck(el) {
    this.el = el;
    this.input = this.el.querySelector('.jsZipCodeCheckInput');
    this.submitBtn = this.el.querySelector('.jsZipCodeCheckSubmitBtn');

    this.el.addEventListener('submit', e => {
        e.preventDefault();
        if (!this.input.value) return;

        this.submitBtn.classList.add('btn--loading');

        se_postRequest(se_ajax.ajaxurl, {
            action: 'get_commune_url_for_zipcode',
            zipcode: this.input.value
        }, response => {
            this.submitBtn.classList.remove('btn--loading');
            response = JSON.parse(response);

            if (response.err || !response.url) return alert('Oeps.. Er ging iets niet helemaal goed. Controleer de invoer en probeer het nogmaals.');
            window.location.href = response.url;
        }, err => {
            this.submitBtn.classList.remove('btn--loading');
            console.error(err);
            return alert('Oeps.. Er ging iets niet helemaal goed. Controleer de invoer en probeer het nogmaals.');
        });
    });
}

(function() {
    const zipCodeCheckEls = document.querySelectorAll('.jsZipCodeCheck');
    zipCodeCheckEls.forEach(el => new ZipCodeCheck(el));
})();

(function() {
    const contrastBtnEl = document.querySelector('.jsAccessibilityContrast');

    if (contrastBtnEl) {
        document.addEventListener('click', e => {
            if (e.target.classList.contains('jsAccessibilityContrast')) {
                e.preventDefault();
                toggleContrast();
            }

            if (e.target.classList.contains('jsAccessibilityFontSize')) {
                e.preventDefault();
                toggleFontSize();
            }
        });
    }

    // Check if there are any cookies
    const contrastCookie = getCookie('ab_contrast');
    if (contrastCookie === 'on') document.documentElement.classList.add('ab-contrast');
    
    const fontSizeCookie = getCookie('ab_font_size');
    if (fontSizeCookie) { document.documentElement.classList.add(fontSizeCookie); }

    // Functions
    function toggleContrast() {
        const date = new Date();
        date.setTime(date.getTime() + (99 * 24 * 60 * 60 * 1000));

        document.documentElement.classList.toggle('ab-contrast');
        document.cookie = 'ab_contrast=' + (document.documentElement.classList.contains('ab-contrast') ? 'on' : 'off') + '; expires=' + date.toGMTString() + '; path=/';
    }

    function toggleFontSize() {
        const date = new Date();
        date.setTime(date.getTime() + (99 * 24 * 60 * 60 * 1000));

        if (document.documentElement.classList.contains('ab-font-size-1')) {
            document.documentElement.classList.remove('ab-font-size-1');
            document.documentElement.classList.add('ab-font-size-2');
            document.cookie = 'ab_font_size=ab-font-size-2; expires=' + date.toGMTString() + '; path=/';
        }
        else if (document.documentElement.classList.contains('ab-font-size-2')) {
            document.documentElement.classList.remove('ab-font-size-2');
            document.cookie = 'ab_font_size=ab-font-size-0; expires=' + date.toGMTString() + '; path=/';
        }
        else {
            document.documentElement.classList.remove('ab-font-size-0');
            document.documentElement.classList.add('ab-font-size-1');
            document.cookie = 'ab_font_size=ab-font-size-1; expires=' + date.toGMTString() + '; path=/';
        }
    }

    function getCookie(c_name) {
        let c_value = " " + document.cookie;
        let c_start = c_value.indexOf(" " + c_name + "=");

        if (c_start == -1) {
            c_value = null;
        }
        else {
            var c_end = c_value.indexOf(";", c_start);
            c_start = c_value.indexOf("=", c_start) + 1;

            if (c_end == -1) c_end = c_value.length;
            c_value = unescape(c_value.substring(c_start,c_end));
        }

        return c_value;
    }
})();

function MorphButton(el) {
    this.el = el;

    this.initialPath = MorphSVGPlugin.convertToPath(this.el.querySelector('.jsInitialPath'));

    this.firstCircleElPath = MorphSVGPlugin.convertToPath(this.el.querySelector('.jsFirstCircle'));
    this.secondCircleElPath = MorphSVGPlugin.convertToPath(this.el.querySelector('.jsSecondCircle'));
    
    this.firstStroke = this.el.querySelector('.jsFirstStroke');
    this.secondStroke = this.el.querySelector('.jsSecondStroke');

    this.animationDuration = 4;

    this.timeline = gsap.timeline({ repeat: -1 })
        .set(this.firstCircleElPath, { morphSVG: this.secondStroke, transformOrigin: '50% 50%' })
        .set(this.secondCircleElPath, { morphSVG: this.firstStroke, transformOrigin: '50% 50%' })

        .to(this.firstCircleElPath, this.animationDuration, { morphSVG: this.firstStroke, ease: Power0.easeNone })
        .to(this.secondCircleElPath, this.animationDuration, { morphSVG: this.secondStroke, scale: 0.95, ease: Power0.easeNone }, '-=' + (this.animationDuration - 0.3))

        .to(this.firstCircleElPath, this.animationDuration, { morphSVG: this.secondStroke, ease: Power0.easeNone })
        .to(this.secondCircleElPath, this.animationDuration, { morphSVG: this.firstStroke, scale: 1, ease: Power0.easeNone }, '-=' + (this.animationDuration - 0.3))
    ;

    if (this.el.classList.contains('jsButtonMorph-paused')) {
        this.timeline.pause();

        gsap.set(this.firstCircleElPath, { morphSVG: { shape: this.secondStroke } });
        gsap.set(this.secondCircleElPath, { morphSVG: { shape: this.firstStroke } });

        this.el.addEventListener('mouseover', _ => this.timeline.play());
        this.el.addEventListener('mouseout', _ => this.timeline.reverse());
    }
}

(function() {
    const btnEls = document.querySelectorAll('.jsButtonMorph');
    btnEls.forEach(el => new MorphButton(el));
})();

(function() {
    const mainHeaderEl = document.querySelector('.jsMainHeader');

    if (mainHeaderEl) {
        const headroom = new Headroom(mainHeaderEl, {
            offset: 40,
            onPin: _ => document.body.classList.remove('header-unpinned'),
            onUnpin: _ => document.body.classList.add('header-unpinned')
        });

        headroom.init();
    }
})();
function Homepage(el) {
    this.el = el;
    this.sectionEls = this.el.querySelectorAll('.jsHomeSection');
    this.activeSectionSlug = 'home';
    this.lastScrollPos = 0;

    this.parallaxStartWidth = 750;

    this.initSectionHome();
    this.initSectionDrop();
    this.initSectionBdg();
    this.initSectionDeklaag();
    this.initSectionPrehistory();
    this.initSectionGrondwater();
    this.initSectionGlas();
    this.initScrollProgressIndicator();

    // Map the section sounds
    this.sectionSoundMap = {
        home: homeSoundUrl,
        drop: dropSoundUrl,
        bdg: bdgSoundUrl,
        deklaag: deklaagSoundUrl,
        prehistory: prehistorySoundUrl,
        grondwater: grondwaterSoundUrl,
        glas: glasSoundUrl
    };

    // Create the section map
    this.sectionMap = [];
    this.sectionEls.forEach(el => {
        const bounds = el.getBoundingClientRect();

        this.sectionMap.push({
            start: bounds.top,
            end: bounds.top + bounds.height,
            section: el.dataset.sectionSlug
        });
    });

    // Init the sound button
    const soundBtnEl = this.el.querySelector('.jsSoundToggleBtn');
    soundBtnEl.addEventListener('click', e => {
        e.preventDefault();

        globalSoundIsOn = !globalSoundIsOn;

        if (globalSoundIsOn) {
            globalAudioPlayer.play();
            soundBtnEl.classList.remove('sound-off');
            soundBtnEl.classList.add('sound-on');
            soundBtnEl.ariaLabel = 'Zet het geluid uit';
        }
        else {
            globalAudioPlayer.pause();
            soundBtnEl.classList.add('sound-off');
            soundBtnEl.classList.remove('sound-on');
            soundBtnEl.ariaLabel = 'Zet het geluid aan';
        }
    });

    window.addEventListener('scroll', _ => this.changeAudioOnScroll());
}

Homepage.prototype.initScrollProgressIndicator = function() {
    this.scrollIndicatorEl = this.el.querySelector('.jsProgressIndicator');
    this.scrollIndicatorProgressEl = this.el.querySelector('.jsProgressIndicatorProgress');
    
    this.setScrollProgressIndicator();
    window.addEventListener('scroll', _ => this.setScrollProgressIndicator());
};

Homepage.prototype.setScrollProgressIndicator = function() {
    const percentage = window.scrollY / (document.body.offsetHeight - window.innerHeight) * 100;
    
    gsap.to(this.scrollIndicatorProgressEl, { width: percentage + '%', duration: 0.2, ease: Power2.easeOut });
};

Homepage.prototype.changeAudioOnScroll = function() {
    if (!globalSoundIsOn) return;

    const scrollDown = this.lastScrollPos < window.scrollY;
    const marker = window.scrollY + (window.innerHeight / 2);

    if (scrollDown) {
        let sectionSlugToActivate = null;

        this.sectionMap.forEach(item => {
            if (marker >= item.start && marker < item.end) sectionSlugToActivate = item.section;
        });
    
        if (sectionSlugToActivate && sectionSlugToActivate !== this.activeSectionSlug) {
            this.activeSectionSlug = sectionSlugToActivate;
            this.activateAudioForSection(sectionSlugToActivate);
        }
    }
    else {
        for (let i = 0; i < this.sectionMap.length; i++) {
            const item = this.sectionMap[i];

            if (marker >= item.start && marker < item.end) {
                if (item.section !== this.activeSectionSlug) {
                    this.activeSectionSlug = item.section;
                    this.activateAudioForSection(item.section);
                }

                break;
            }
        }
    }

    this.lastScrollPos = window.scrollY >= 0 ? window.scrollY : 0;
};

Homepage.prototype.activateAudioForSection = function(sectionSlug) {
    if (!globalSoundIsOn || globalAudioPlayer.src === this.sectionSoundMap[sectionSlug]) return;

    gsap.timeline()
        .to(globalAudioPlayer, 0.5, { volume: 0 })
        .add(_ => {
            globalAudioPlayer.src = this.sectionSoundMap[sectionSlug];
            globalAudioPlayer.play();
        })
        .to(globalAudioPlayer, 0.5, { volume: 1 })
    ;
};

Homepage.prototype.initSectionHome = function() {
    const downBtnEl = this.el.querySelector('.jsHomeOverlay .jsDownBtn');
    const logoEl = this.el.querySelector('.jsLogo');
    const bottomTextEl = this.el.querySelector('.jsBottomText');

    gsap.timeline()
        .to(1, { opacity: 1, ease: Power2.easeInOut })
        .to([logoEl, bottomTextEl, downBtnEl], 1.5, { y: 0, opacity: 1, ease: Power2.easeInOut, stagger: 0.3 }, '-=0.5')
    ;

    // Init the down button
    downBtnEl.addEventListener('click', e => {
        e.preventDefault();
        vanillaSmoothie.scrollTo((window.innerHeight), { duration: 2000, easing: 'easeInOutQuad' });
    });
};

Homepage.prototype.initSectionDrop = function() {
    const dropSectionEl = this.el.querySelector('.jsSectionDrop');
    const dropOverlayEl = this.el.querySelector('.jsDropOverlay');

    const dropEl = this.el.querySelector('.jsDrop');
    const clouds1El = this.el.querySelector('.jsClouds');
    const clouds2El = this.el.querySelector('.jsClouds2');
    const buttons = dropOverlayEl.querySelectorAll('.button');

    // Cloud timeline
    if (window.innerWidth >= this.parallaxStartWidth) {
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: dropSectionEl,
                scrub: true,
                start: 'top bottom',
                end: '+=' + dropSectionEl.offsetHeight * 2
            }
        });
    
        timeline.to([clouds1El, clouds2El], 1, { y: -(window.innerWidth * 0.18), scale: 1.05, ease: Power0.easeNone });
    
    
        // Drop timeline
        const timeline2 = gsap.timeline({
            scrollTrigger: {
                trigger: dropSectionEl,
                scrub: true,
                start: 'top bottom',
                end: '+=' + (dropSectionEl.offsetHeight * 1.5)
            }
        });
    
        timeline2.to(dropEl, 1, { y: dropSectionEl.offsetHeight * 0.75, rotate: 45, scale: 0, ease: Power2.easeInOut });
        timeline2.to(dropEl, 0.5, { opacity: 0, ease: Power2.easeInOut }, '-=0.5');
    }

    // Show the buttons on enter
    gsap.set(buttons, { scale: 0.5 });
    inView.offset({ top: 80, right: 0, bottom: 80, left: 0 });

    inView('.jsDropOverlay .button')
        .on('enter', function(el) {
            gsap.timeline()
                .to(el, 0.6, { scale: 1, ease: Bounce.easeOut })
                .to(el, 0.6, { opacity: 1, ease: Power2.easeInOut }, '-=0.6')
                .add(_ => el.classList.add('animation'))
            ;
        })
    ;
};

Homepage.prototype.initSectionBdg = function() {
    const sectionEl = this.el.querySelector('.jsSectionBdg');
    const layer1El = sectionEl.querySelector('.layer1');
    const layer2El = sectionEl.querySelector('.layer2');
    const buttons = sectionEl.querySelectorAll('.button');

    if (window.innerWidth >= this.parallaxStartWidth) {
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: sectionEl,
                scrub: true,
                start: 'top bottom',
                end: '+=' + sectionEl.offsetHeight * 2
            }
        });
    
        timeline.to(layer1El, 1, { y: -(window.innerWidth * 0.20), ease: Power0.easeNone });
    
    
        const timeline2 = gsap.timeline({
            scrollTrigger: {
                trigger: sectionEl,
                scrub: true,
                start: 'top bottom',
                end: '+=' + sectionEl.offsetHeight * 2
            }
        });
    
        timeline2.to(layer2El, 1, { y: -(window.innerWidth * 0.1), ease: Power0.easeNone });
    }

    // Show the buttons on enter
    gsap.set(buttons, { scale: 0.5 });
    inView.offset({ top: 80, right: 0, bottom: 80, left: 0 });

    inView('.jsSectionBdg .button')
        .on('enter', function(el) {
            gsap.timeline()
                .to(el, 0.6, { scale: 1, ease: Bounce.easeOut })
                .to(el, 0.6, { opacity: 1, ease: Power2.easeInOut }, '-=0.6')
                .add(_ => el.classList.add('animation'))
            ;
        })
    ;
};

Homepage.prototype.initSectionDeklaag = function() {
    const sectionEl = this.el.querySelector('.jsSectionDeklaag');
    const layer1El = sectionEl.querySelector('.layer1');
    const layer2El = sectionEl.querySelector('.layer2');
    const layer3El = sectionEl.querySelector('.layer3');
    const buttons = sectionEl.querySelectorAll('.button');

    if (window.innerWidth >= this.parallaxStartWidth) {
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: sectionEl,
                scrub: true,
                start: 'top bottom',
                end: '+=' + sectionEl.offsetHeight * 2
            }
        });
    
        timeline.to(layer1El, 1, { y: -(window.innerWidth * 0.15), ease: Power0.easeNone });
    
    
        const timeline2 = gsap.timeline({
            scrollTrigger: {
                trigger: sectionEl,
                scrub: true,
                start: 'top bottom',
                end: '+=' + sectionEl.offsetHeight * 2
            }
        });
    
        timeline2.to(layer2El, 1, { y: -(window.innerWidth * 0.1), ease: Power0.easeNone });
    
    
        // Layer 3 animation
        const timeline3 = gsap.timeline({
            scrollTrigger: {
                trigger: sectionEl,
                scrub: true,
                start: 'top bottom',
                end: '+=' + sectionEl.offsetHeight
            }
        });
    
        timeline3.to(sectionEl, 1, { y: -(window.innerWidth * 0.12), ease: Power2.easeOut });
    }

    // Show the buttons on enter
    gsap.set(buttons, { scale: 0.5 });
    inView.offset({ top: 80, right: 0, bottom: 80, left: 0 });

    inView('.jsSectionDeklaag .button')
        .on('enter', function(el) {
            gsap.timeline()
                .to(el, 0.6, { scale: 1, ease: Bounce.easeOut })
                .to(el, 0.6, { opacity: 1, ease: Power2.easeInOut }, '-=0.6')
                .add(_ => el.classList.add('animation'))
            ;
        })
    ;
};

Homepage.prototype.initSectionPrehistory = function() {
    const sectionEl = this.el.querySelector('.jsSectionPrehistory');
    const layer1El = sectionEl.querySelector('.layer1');
    const buttons = sectionEl.querySelectorAll('.button');


    if (window.innerWidth >= this.parallaxStartWidth) {
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: sectionEl,
                scrub: true,
                start: 'top bottom',
                end: '+=' + sectionEl.offsetHeight * 2
            }
        });
    
        timeline.to(layer1El, 1, { y: -(window.innerWidth * 0.25), ease: Power0.easeNone });
    }

    // Show the buttons on enter
    gsap.set(buttons, { scale: 0.5 });
    inView.offset({ top: 80, right: 0, bottom: 80, left: 0 });

    inView('.jsSectionPrehistory .button')
        .on('enter', function(el) {
            gsap.timeline()
                .to(el, 0.6, { scale: 1, ease: Bounce.easeOut })
                .to(el, 0.6, { opacity: 1, ease: Power2.easeInOut }, '-=0.6')
                .add(_ => el.classList.add('animation'))
            ;
        })
    ;
};

Homepage.prototype.initSectionGrondwater = function() {
    const sectionEl = this.el.querySelector('.jsSectionGrondwater');
    const layer1El = sectionEl.querySelector('.layer1');
    const buttons = sectionEl.querySelectorAll('.button');

    if (window.innerWidth >= this.parallaxStartWidth) {
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: sectionEl,
                scrub: true,
                start: 'top bottom',
                end: '+=' + sectionEl.offsetHeight * 2
            }
        });
    
        timeline.to(layer1El, 1, { y: -(window.innerWidth * 0.25), ease: Power0.easeNone });
    }

    // Show the buttons on enter
    gsap.set(buttons, { scale: 0.5 });
    inView.offset({ top: 80, right: 0, bottom: 80, left: 0 });

    inView('.jsSectionGrondwater .button')
        .on('enter', function(el) {
            gsap.timeline()
                .to(el, 0.6, { scale: 1, ease: Bounce.easeOut })
                .to(el, 0.6, { opacity: 1, ease: Power2.easeInOut }, '-=0.6')
                .add(_ => el.classList.add('animation'))
            ;
        })
    ;
};

Homepage.prototype.initSectionGlas = function() {
    const sectionEl = this.el.querySelector('.jsSectionGlas');
    const layer1El = sectionEl.querySelector('.layer1');
    const layer3El = sectionEl.querySelector('.layer3');
    const buttons = sectionEl.querySelectorAll('.button');

    if (window.innerWidth >= this.parallaxStartWidth) {
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: sectionEl,
                scrub: true,
                start: 'top bottom',
                end: '+=' + sectionEl.offsetHeight
            }
        });
    
        timeline.to(layer1El, 1, { y: -(window.innerWidth * 0.25), ease: Power0.easeNone });


        // Ceiling animation
        const timeline2 = gsap.timeline({
            scrollTrigger: {
                trigger: sectionEl,
                scrub: true,
                start: 'top bottom',
                end: '+=' + sectionEl.offsetHeight * 2
            }
        });

        timeline2.to(layer3El, 1, { y: -(window.innerWidth * 0.25), ease: Power0.easeNone });
    }

    // Show the buttons on enter
    gsap.set(buttons, { scale: 0.5 });
    inView.offset({ top: 80, right: 0, bottom: 80, left: 0 });

    inView('.jsSectionGlas .button')
        .on('enter', function(el) {
            gsap.timeline()
                .to(el, 0.6, { scale: 1, ease: Bounce.easeOut })
                .to(el, 0.6, { opacity: 1, ease: Power2.easeInOut }, '-=0.6')
                .add(_ => el.classList.add('animation'))
            ;
        })
    ;
};


Homepage.prototype.setElementAspectRatio = function(el, ratio, minHeight) {
    el.style.width = '';
    el.style.height = '';

    let newWidth = window.innerWidth;
    let newHeight = (el.offsetWidth / ratio[0]) * ratio[1];

    if (newHeight < minHeight) {
        newHeight = minHeight;
        newWidth = (newHeight / ratio[1]) * ratio[0];
    }

    el.style.width = newWidth + 'px';
    el.style.height = newHeight + 'px';
};

(function() {
    const homeEl = document.querySelector('.jsHome');
    if (homeEl) new Homepage(homeEl);
})();
function HomeInfobox(el) {
    this.el = el;
    this.elInner = this.el.querySelector('.jsHomeInfoboxInner');

    this.focusedElBeforeOpen = null;
    this.focusableEls = this.el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    this.firstFocusableEl = this.focusableEls[0];
    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];

    this.el.addEventListener('click', e => {
        if (e.target.classList.contains('jsHomeInfoboxClose')) {
            e.preventDefault();
            this.hide();
        }
    });

    window.addEventListener('keyup', e => {
        if (e.key.toLowerCase() === 'escape') this.hide();
    });

    window.addEventListener('keydown', e => {
        const tabIsPressed = e.key === 'Tab';

        if (!tabIsPressed) return;

        if (e.shiftKey) {
            if (document.activeElement === this.firstFocusableEl) {
                this.lastFocusableEl.focus();
                e.preventDefault();
            }
        }
        else {
            if (document.activeElement === this.lastFocusableEl) {
                this.firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    });
}

HomeInfobox.prototype.show = function(clickedTarget) {
    if ((typeof clickedTarget !== undefined || clickedTarget !== null) && clickedTarget) {
        const parentSectionEl = clickedTarget.closest('.jsHomeSection');

        if (parentSectionEl) this.setFocusToSection(parentSectionEl, _ => this._show());
        else this._show();
    }
    else {
        this._show();
    }
};

HomeInfobox.prototype._show = function() {
    document.body.classList.add('infobox-open');

    gsap.timeline()
        .set(this.el, { opacity: 0 })
        .set(this.elInner, { xPercent: 100 })

        .add(_ => {
            this.el.classList.add('show');
            this.firstFocusableEl.focus();
        })

        .to(this.el, 0.5, { opacity: 1, ease: Power2.easeInOut })
        .to(this.elInner, 0.5, { xPercent: 0, ease: Power2.easeInOut }, '-=0.2')
    ;

    // Accessibility stuff
    this.focusedElBeforeOpen = document.activeElement;
    document.body.ariaHidden = true;
    this.el.ariaHidden = false;
};

HomeInfobox.prototype.hide = function() {
    document.body.classList.remove('infobox-open');

    gsap.timeline()
        .to(this.elInner, 0.5, { xPercent: 100, ease: Power2.easeInOut })
        .to(this.el, 0.5, { opacity: 0, ease: Power2.easeInOut }, '-=0.2')
        .add(_ => this.el.classList.remove('show'));
    ;

    // Accessibility stuff
    this.focusedElBeforeOpen.focus();
    this.focusedElBeforeOpen = null;
    document.body.ariaHidden = false;
    this.el.ariaHidden = true;
};

HomeInfobox.prototype.setFocusToSection = function(sectionEl, callback) {
    if (callback) callback();
    return;
    // const bounds = sectionEl.getBoundingClientRect();

    // vanillaSmoothie.scrollTo(window.scrollY + bounds.top, { duration: 500, easing: 'easeOutQuad' });
    // setTimeout(callback, 250);
};

(function() {
    const infoboxes = {};

    document.addEventListener('click', e => {
        if (e.target.classList.contains('jsHomeInfoboxTrigger')) {
            if (e.target.dataset.infoboxId) {
                const infoboxId = e.target.dataset.infoboxId;

                // Play a sound
                if (typeof globalSoundIsOn !== 'undefined' && globalSoundIsOn === true) {
                    const clickSound = new Audio(clickSoundUrl);
                    clickSound.play();
                }

                if (typeof infoboxes[infoboxId] !== 'undefined') {
                    infoboxes[infoboxId].show(e.target);
                }
                else {
                    // Get the infobox element
                    const boxEl = document.body.querySelector('.jsHomeInfobox[data-infobox-id="' + infoboxId + '"]');

                    // Create the infobox and show it
                    if (boxEl) {
                        infoboxes[infoboxId] = new HomeInfobox(boxEl);
                        infoboxes[infoboxId].show(e.target);
                    }
                    else {
                        console.error('Cannot find an infobox with id', infoboxId);
                    }
                }
            }
            else {
                console.error('Target has no infobox id');
            }
        }
    });
})();
function Campagne2024(el) {
    this.el = el;
    this.innerWrapperEl = this.el.querySelector('.jsInnerWrapper');
    this.innerEl = this.el.querySelector('.jsInner');
    this.prevBtnEl = this.el.querySelector('.jsPrevBtn');
    this.nextBtnEl = this.el.querySelector('.jsNextBtn');
    this.colWidth = this.el.querySelector('.jsCol').offsetWidth;
    this.colCorrection = 0.8;
    this.modalEl = this.el.querySelector('.jsModal');
    this.endScreenEl = this.el.querySelector('.jsEndScreen');
    this.endScreenVisible = false;

    // Prepare the inner element for the transition
    this.innerEl.style.transform = `translateX(0px)`;

    this.setColWidth();
    this.setCentered();
    this.initEventListeners();
    this.checkBoundary(0);
    this.initModal();
}

Campagne2024.prototype.moveInnerEl = function (direction) {
    const windowWidth = window.innerWidth;
    const innerElWidth = this.innerEl.offsetWidth;

    const currentPosition = this.innerEl.getBoundingClientRect().x;
    let newPosition = 0;
    const percentage = Math.abs(currentPosition / (innerElWidth - windowWidth)) * 100;

    if (this.el.classList.contains('centered')) {
        if (direction === 'next') this.showEndScreen();
        else this.hideEndScreen();

        return;
    }

    if (direction === 'next') {
        if (percentage >= 100) {
            this.showEndScreen();
            return;
        }
        else {
            if (percentage < 49) newPosition = -((this.colWidth * 1.5) - (windowWidth / 2)); // Move to col 2
            else newPosition = -((this.colWidth * 2.5) - (windowWidth / 2)); // Move to col 3    

            // Prevent position overflow
            if (newPosition <= -(innerElWidth - windowWidth)) newPosition = -(innerElWidth - windowWidth);
        }
    }
    else if (direction === 'prev') {
        if (this.endScreenVisible) {
            this.hideEndScreen();
            return;
        }

        if (percentage > 51) newPosition = -((this.colWidth * 1.5) - (windowWidth / 2)); // Move to col 2
        else newPosition = -((this.colWidth / 2) - (windowWidth / 2)); // Move to col 1

        // Prevent position overflow
        if (newPosition >= 0) newPosition = 0;
    }

    gsap.to(this.innerEl, { duration: 1.5, x: newPosition, ease: 'power2.out' });
    this.checkBoundary(Math.round(newPosition));
};

Campagne2024.prototype.checkBoundary = function (currentPosition) {
    const windowWidth = window.innerWidth;
    const innerElWidth = this.innerEl.offsetWidth;

    if (currentPosition === 0 && window.innerWidth >= (this.colWidth * this.colCorrection) && window.innerWidth < this.colWidth) { // We use the centered view, but we need to center the first view
        this.innerEl.style.transform = `translateX(-${(this.colWidth * 0.5) - (windowWidth / 2)}px)`;
    }
    else {
        // Make sure we don't go beyond the boundaries on screen resize
        if (currentPosition >= 0) this.innerEl.style.transform = `translateX(0px)`;
        else if (currentPosition <= -(innerElWidth - windowWidth)) this.innerEl.style.transform = `translateX(${-(innerElWidth - windowWidth)}px)`;
    }

    // Enable or disable the prev button
    // if (currentPosition >= 0) this.prevBtnEl.classList.add('hidden');
    // else this.prevBtnEl.classList.remove('hidden');

    // Enable or disable the next button
    // if (currentPosition <= -(innerElWidth - windowWidth)) this.nextBtnEl.classList.add('hidden');
    // else this.nextBtnEl.classList.remove('hidden');

    // Activate the correct segment
    const percentage = Math.abs(currentPosition / (innerElWidth - windowWidth)) * 100;
    this.activateSegment(this.getSegmentByPercentage(percentage));
};

Campagne2024.prototype.showEndScreen = function() {
    const duration = 0.75;
    this.endScreenVisible = true;

    gsap.timeline()
        .set(this.endScreenEl, { xPercent: 100 })
        .add(() => this.endScreenEl.classList.add('is-active'))
        .to(this.endScreenEl, { duration: duration, xPercent: 0, ease: 'power2.inOut' })
        .to(this.innerWrapperEl, { duration: duration, xPercent: -20, ease: 'power2.inOut' }, '-=' + duration);
};

Campagne2024.prototype.hideEndScreen = function() {
    const duration = 0.75;
    this.endScreenVisible = false;

    gsap.timeline()
        .to(this.endScreenEl, { duration: duration, xPercent: 100, ease: 'power2.inOut' })
        .to(this.innerWrapperEl, { duration: duration, xPercent: 0, ease: 'power2.inOut' }, '-=' + duration)
        .add(() => this.endScreenEl.classList.remove('is-active'));
};

Campagne2024.prototype.activateSegment = function (segment) {
    this.el.classList.remove('segment-1');
    this.el.classList.remove('segment-2');
    this.el.classList.remove('segment-3');

    this.el.classList.add('segment-' + segment);
};

Campagne2024.prototype.getSegmentByPercentage = function (percentage) {
    if (percentage < 40) return 1;
    if (percentage < 80) return 2;
    return 3;
};

Campagne2024.prototype.initEventListeners = function () {
    this.prevBtnEl.addEventListener('click', this.onPrevBtnClick.bind(this));
    this.nextBtnEl.addEventListener('click', this.onNextBtnClick.bind(this));

    window.addEventListener('resize', () => {
        this.setColWidth();
        this.setCentered();
        this.checkBoundary(this.innerEl.getBoundingClientRect().x);
    });

    this.endScreenEl.addEventListener('click', e => {
        if (e.target.classList.contains('jsPrevBtn')) {
            e.preventDefault();
            this.hideEndScreen();
        }
    });
};

Campagne2024.prototype.setCentered = function () {
    if (window.innerWidth > this.innerEl.offsetWidth) {
        this.el.classList.add('centered');
        this.innerEl.style.transform = `translateX(0)`;
    }
    else {
        this.el.classList.remove('centered');
    }
};

Campagne2024.prototype.onPrevBtnClick = function () {
    this.moveInnerEl('prev');
};

Campagne2024.prototype.onNextBtnClick = function () {
    this.moveInnerEl('next');
};

Campagne2024.prototype.setColWidth = function () {
    this.colWidth = this.el.querySelector('.jsCol').offsetWidth;
};

Campagne2024.prototype.initModal = function () {
    this.el.addEventListener('click', e => {
        if (e.target.classList.contains('jsModalTrigger')) {
            e.preventDefault();

            const text = e.target.dataset.text ? JSON.parse(e.target.dataset.text) : '';
            const url = e.target.dataset.url;
            const btnText = e.target.dataset.btnText;

            const contentEl = this.modalEl.querySelector('.jsContent');
            const btnEl = this.modalEl.querySelector('.jsBtn');

            contentEl.innerHTML = text;
            btnEl.href = url;
            btnEl.innerHTML = btnText;

            this.showModal();
        }
    });

    this.modalEl.addEventListener('click', e => {
        if (e.target.classList.contains('jsClose')) {
            e.preventDefault();
            this.hideModal();
        }
    });

    window.addEventListener('keyup', e => {
        if (e.key.toLowerCase() === 'escape') {
            this.hideModal();
        }
    });
};

Campagne2024.prototype.showModal = function () {
    if (this.modalEl.classList.contains('is-active')) return;

    const innerEl = this.modalEl.querySelector('.jsInner');

    gsap.timeline()
        .set(this.modalEl, { opacity: 0 })
        .set(innerEl, { yPercent: 100 })

        .add(() => this.modalEl.classList.add('is-active'))

        .to(this.modalEl, { duration: 0.5, opacity: 1, ease: 'power2.inOut' })
        .to(innerEl, { duration: 0.5, yPercent: 0, ease: 'power2.out' }, '-=0.5');
};

Campagne2024.prototype.hideModal = function () {
    if (!this.modalEl.classList.contains('is-active')) return;

    const innerEl = this.modalEl.querySelector('.jsInner');

    gsap.timeline()
        .to(this.modalEl, { duration: 0.5, opacity: 0, ease: 'power2.inOut' })
        .to(innerEl, { duration: 0.5, yPercent: 100, ease: 'power2.out' }, '-=0.5')

        .add(() => this.modalEl.classList.remove('is-active'))
    ;
};

(function () {
    const campagneEl = document.querySelector('.jsCampagne2024');
    if (campagneEl) new Campagne2024(campagneEl);
})();
function PhotoCompetitionTabs(el) {
    this.el = el;

    this.headerBtns = this.el.querySelectorAll('.jsHeaderBtn');
    this.tabs = this.el.querySelectorAll('.jsTab');

    this.headerBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            this.tabs.forEach(tab => tab.classList.remove('active'));
            this.headerBtns.forEach(btn => btn.classList.remove('btn--darkblue'));
            btn.classList.add('btn--darkblue');

            const tab = this.el.querySelector(`.jsTab[data-tab="${btn.dataset.tab}"]`);
            tab.classList.add('active');
        });
    });
}

(function() {
    const tabEls = document.querySelectorAll('.jsFotowedstrijdInzendingenTabs');
    tabEls.forEach(el => new PhotoCompetitionTabs(el));
})();


const scrollToWinnersBtn = document.querySelector('.jsScrollToWinners');

if (scrollToWinnersBtn) {
    scrollToWinnersBtn.addEventListener('click', e => {
        e.preventDefault();

        const bounds = scrollToWinnersBtn.getBoundingClientRect();
        vanillaSmoothie.scrollTo(bounds.top + window.scrollY + bounds.height, { duration: 500, easing: 'easeOutQuad' });
    });
}